import { Plugin, PluginKey } from '@tiptap/pm/state';
import type { Node as ProseMirrorNode } from 'prosemirror-model';

export const preventNewLinesInsideTable = (prefix: string) =>
  new Plugin({
    key: new PluginKey(`prevent-new-lines-inside-table-${prefix}`),
    props: {
      handlePaste(view, event) {
        // Get the current selection
        const { state, dispatch } = view;
        const { schema, selection } = state;

        // Check if pasting inside a table cell
        const isInsideTableCell =
          state.schema.nodes.tableCell &&
          selection.$from.node(-1).type === state.schema.nodes.tableCell;

        const isInsideTableHeader =
          state.schema.nodes.tableHeader &&
          selection.$from.node(-1).type === state.schema.nodes.tableHeader;

        if (isInsideTableCell || isInsideTableHeader) {
          event.preventDefault();

          // Get plain text from clipboard
          const clipboardText: string = event.clipboardData?.getData('text/plain') || '';

          // Split the text by newlines
          const lines: string[] = clipboardText.split('\n');

          // Convert each line into a text node with a hard break
          const contentNodes: ProseMirrorNode[] = [];

          lines.forEach((line, index) => {
            if (line.trim()) {
              contentNodes.push(schema.text(line));
            }

            if (index < lines.length - 1) {
              contentNodes.push(schema.nodes.hardBreak.create());
            }
          });

          // Wrap everything inside a single paragraph node
          const paragraphNode = schema.nodes.paragraph.create({}, contentNodes);

          // Replace the selection with the single paragraph
          dispatch(state.tr.replaceSelectionWith(paragraphNode));

          return true;
        }
        return false;
      },
    },
  });
